import { type ReactNode } from 'react';
import { useSession } from '@/lib/use-session';
import LoginPage from '@/pages/LoginPage';

/**
 * AuthGuard — wrap routes ที่ต้อง login
 * Loading → spinner / blank
 * No session → LoginPage
 * Has session → render children
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const { isLoading, user } = useSession();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        กำลังตรวจสอบสถานะการ login...
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
